/* global dataLayer */

import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SummaryList from '../SummaryList';
import AddWardrobe from '../AddWardrobe';
import SummaryBar from '../SummaryBar';
import { EventsDataContext } from '../../contexts/EventsDataContext';
import {
  sendDataToExternalBasket,
  submitAjaxToBrw,
  submitLogFromBrw,
} from '../../store/actions/basket';
import { reactLocalStorage } from 'reactjs-localstorage';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import calculatePrice from '../../helpers/calculatePrice';
import { checkFreeAccessories } from '../../helpers/wardrobe';
import { getToken } from '../../store/actions/token';
import RealizationTime from '../common/RealizationTime';

const mergeElements = elements => {
  const fronts = elements.fronty;
  const body = elements.korpus;
  const equipment = elements.wyposazenie;
  const list = [...fronts, body, ...equipment];
  return list;
};

const forAll = resp => {
  const list = resp.pakiety.map(item => mergeElements(item.elements));
  return list.flat().map(item => {
    return {
      name: item.name,
      id: item.name,
      price: item.price,
      quantity: 1,
    };
  });
};

const SummaryOptions = props => {
  const {
    setOpenDoorsState,
    addWardrobe,
    changeBodyType,
    shoppingList,
    configuratorMode,
    changeConfiguratorMode,
    setHighlightedWardrobe,
    setNotHighlightedWardrobe,
    sendDataToExternalBasket,
    submitAjaxToBrw,
    submitLogFromBrw,
  } = props;

  const { optionsVisibility, setOptionsVisibility } = useContext(EventsDataContext);
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);

  const bodyOverlay = document.body.classList.contains('overlay');
  const [loading, setLoading] = React.useState(false);

  const history = useHistory();

  const getImageFromCanvas = doorState => {
    setOpenDoorsState(doorState);
    return new Promise(resolve => {
      setTimeout(() => {
        const canvasRenderer = window.brwRenderer;
        canvasRenderer.render(window.brwScene, window.brwCamera);
        resolve(canvasRenderer.domElement.toDataURL());
      }, 100);
    });
  };

  const getImagesFromCanvas = doorState => {
    let promiseList = [];
    wardrobesConfigs.forEach((item, index) => {
      promiseList.push(
        new Promise(resolve => {
          setTimeout(() => {
            setOpenDoorsState(doorState);
            setNotHighlightedWardrobe(index);
            const canvasRenderer = window.brwRenderer;
            canvasRenderer.render(window.brwScene, window.brwCamera);
            resolve(canvasRenderer.domElement.toDataURL());
          }, 100);
        }),
      );
    });

    promiseList.push(
      new Promise(resolve => {
        setTimeout(() => {
          setOpenDoorsState(doorState);
          setNotHighlightedWardrobe(undefined);
          const canvasRenderer = window.brwRenderer;
          canvasRenderer.render(window.brwScene, window.brwCamera);
          resolve(canvasRenderer.domElement.toDataURL());
        }, 100);
      }),
    );

    return Promise.all(promiseList);
  };

  useEffect(() => {
    reactLocalStorage.remove('copyWardrobe');
    reactLocalStorage.remove('summaryCopy');

    wardrobesConfigs.forEach(product => {
      const { accessories } = calculatePrice(product);
      product.free_accessories = checkFreeAccessories(accessories);
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const hideEditButton = e => {
      if (e.key === 'H' || e.key === 'h') {
        setOptionsVisibility(prev => {
          return {
            ...prev,
            printMode: !prev.printMode,
          };
        });
      }
    };

    const removeOverlay = e => {
      if (e.target.tagName === 'BODY' || e.target.tagName === 'CANVAS') {
        setOptionsVisibility(prev => {
          return {
            ...prev,
            share: false,
            addWardrobe: false,
            optionsButton: false,
          };
        });
      }
      if (e.target.className === 'overlay') {
        document.body.classList.remove('overlay');
        setOptionsVisibility(prev => {
          return {
            ...prev,
            optionsButton: false,
          };
        });
      }
    };

    document.addEventListener('keydown', hideEditButton);
    document.addEventListener('mousedown', removeOverlay);
    return () => {
      setOptionsVisibility(prev => {
        return {
          ...prev,
          optionsButton: false,
        };
      });
      document.removeEventListener('keydown', hideEditButton);
      document.removeEventListener('mousedown', removeOverlay);
    };
  }, [setOptionsVisibility]);

  const changeMode = () => {
    changeConfiguratorMode(8);
    setOptionsVisibility({ ...optionsVisibility, share: !optionsVisibility.share });
  };

  const getImagesFromCanvasOpenDoor = async () => {
    const blob = await getImagesFromCanvas(true);
    return blob;
  };

  const getImagesFromCanvasCloseDoor = async () => {
    const blob = await getImagesFromCanvas(false);
    return blob;
  };

  const getImageFromCanvasOpenDoor = async () => {
    const blob = await getImageFromCanvas(true);
    return blob;
  };

  const getImageFromCanvasCloseDoor = async () => {
    const blob = await getImageFromCanvas(false);
    return blob;
  };

  const sendDataToBasket = async () => {
    setLoading(true);

    const openDoor = await getImagesFromCanvasOpenDoor();
    const closeDoor = await getImagesFromCanvasCloseDoor();

    const token = reactLocalStorage.get('token', false);
    if (token) {
      sendDataToExternalBasket(openDoor, closeDoor)
        .then(result => {
          setOpenDoorsState(false);
          submitAjaxToBrw(result.data.result.order).then(response => {
            if (result?.data?.result?.order) {
              const products = forAll(JSON.parse(result.data.result.order));

              dataLayer.push({
                ecommerce: null,
              });
              dataLayer.push({
                event: 'addToCart',
                ecommerce: {
                  // currencyCode: 'PLN',
                  add: {
                    // 'add' actionFieldObject measures.
                    products: products,
                  },
                },
              });
            }
            submitLogFromBrw(token, response.data);
            // 1 - jeśli jest wszystko OK
            if (response.data.status === 1) {
              history.push('/basket');
              setLoading(false);
            }
          });
        })
        .catch(() => {
          setOpenDoorsState(false);
        });
    }
  };

  const getPricesInfo = () => {
    let wardrobesPrices = [];
    wardrobesConfigs.forEach(element => {
      wardrobesPrices.push(calculatePrice(element));
    });

    return wardrobesPrices;
  };

  const btnText = !bodyOverlay ? 'Do koszyka' : 'Gotowe';
  const buttonText = loading ? 'Ładowanie...' : btnText;

  return (
    <div>
      <div className="summary-options">
        <AddWardrobe
          addWardrobe={addWardrobe}
          changeBodyType={changeBodyType}
          configuratorMode={configuratorMode}
        />
        {!bodyOverlay ? (
          <SummaryList itemsList={shoppingList} setHighlightedWardrobe={setHighlightedWardrobe} />
        ) : null}
        <SummaryBar
          getImageFromCanvasOpenDoor={getImageFromCanvasOpenDoor}
          getImageFromCanvasCloseDoor={getImageFromCanvasCloseDoor}
          getPricesInfo={getPricesInfo}
          btnText={buttonText}
          btnFunction={!bodyOverlay ? sendDataToBasket : changeMode}
          share={true}
        />
      </div>
      <RealizationTime />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.token.token,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    sendDataToExternalBasket: (imagesOpenDoor, imagesCloseDoor) => {
      return dispatch(sendDataToExternalBasket(ownProps.token, imagesOpenDoor, imagesCloseDoor));
    },
    submitAjaxToBrw: payload => {
      return dispatch(submitAjaxToBrw(payload));
    },
    submitLogFromBrw: (token, payload) => {
      return dispatch(submitLogFromBrw(token, payload));
    },
    getToken: () => {
      return dispatch(getToken(false));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryOptions);
